export default {
	DataType: {
		Appetite: "Appetite",
		Biomass: "Biomass",
		Dose: "Dose",
		FeedAmount: "Feed Amount",
		FishWeight: "Fish Weight",
		HandFeedWeight: "Hand Feed Weight",
		Intensity: "Intensity",
		Loadcell: "Loadcell",
		ManualAmount: "Manual Amount",
		Mean: "Mean",
		PelletCount: "Pellet Count",
		PelletFishMinute: "Pellet Fish Minute",
		Planned: "Planned",
		Recommended: "Recommended",
		SFR: "SFR",
		SGR: "SGR",
		StandardAppetite: "Standard Appetite",
		Target: "Target",
		TodayAppetite: "Today Appetite",
		TotalFeedWeight: "Total Feed Weight",
		avgWeight: "Average Weight",
		blowerSpeed: "Blower Speed",
		compass: "Compass",
		conductivity: "Conductivity",
		fcr: "FCR",
		feedStoreAmount: "Feed Store Amount",
		humidity: "Humidity",
		latitude: "Latitude",
		longitude: "Longitude",
		pellet_count: "Pellet Count",
		pressure: "Pressure",
		pressurePipe: "Pressure Pipe",
		recommendedFeedWeight: "Recommended Feed Weight",
		runtime: "Runtime",
		sal_conductivity: "Salinity Conductivity",
		sal_density: "Salinity Density",
		sal_sound_speed: "Salinity Sound Speed",
		sal_temp: "Salinity Temperature",
		saturation: "Saturation",
		sc_abs_tilt: "Sea Current Absolute Tilt",
		sc_heading: "Sea Current Heading",
		sc_max_tilt: "Sea Current Max Tilt",
		sc_sp_standard: "Sea Current Speed Standard",
		sc_std_tilt: "Sea Current Standard Tilt",
		sc_strength: "Sea Current Strength",
		sc_tilt_x: "Sea Current Tilt X",
		sc_tilt_y: "Sea Current Tilt Y",
		sea_current_absolute_speed: "Sea Current Speed",
		sea_current_direction: "Sea Current Direction",
		sea_current_east: "Sea Current East",
		sea_current_north: "Sea Current North",
		sensor_depth: "Sensor Depth",
		sgr: "SGR",
		smartSpreaderCycleTime: "Smart Spreader Cycle Time",
		smartSpreaderCyclicMax: "Smart Spreader Cyclic Max",
		smartSpreaderCyclicMin: "Smart Spreader Cyclic Min",
		smartSpreaderManualSpeed: "Smart Spreader Manual Speed",
		targetRecommended: "Target Recommended",
		temperatureFeedingLine: "Temperature Feeding Line",
		water_oxygen_mg_l: "Oxygen (mg/L)",
		water_oxygen_percentage: "Oxygen (%)",
		water_oxygen_umol: "Oxygen (μmol)",
		water_salinity: "Salinity",
		water_temperature: "Temperature",
		wind_direction: "Wind Direction",
		wind_speed: "Wind Speed",
	},
};
